<template>
  <div class="factoring-container">
    <div class="project-table">
      <avue-crud
        ref="crud"
        :option="tableConfig"
        :data="tableData"
        v-model="form"
        :page.sync="page"
        :search.sync="searchForm"
        :table-loading="loading"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @selection-change="selectionChange"
        @row-save="rowSave"
        @row-update="rowUpdate"
      >
        <template slot="fileCwbbForm" slot-scope="scope">
          <div class="upload-container">
            <WordUpload
              @showFileName="showFileNameCwbb"
              fileMenuName="保理业务财务报表附件"
              :id="virtualId"
              :plain="true"
              :tip="true"
            />
            <div class="">
              <template v-for="(item, index) in fileCwbb">
                <div class="file_wrapper" :key="index">
                  <a
                    class="file_button"
                    target="_blank"
                    :href="
                      isWord(item.fileUrl)
                        ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                          item.fileUrl
                        : item.fileUrl
                    "
                    type="text"
                    size="small"
                  >
                    {{ item.fileName }}
                  </a>
                  <i
                    @click="downLoadFile(item.id)"
                    class="el-icon-download del_icon"
                  ></i>
                  <i
                    @click="delFile(item.id, index, 'fileCwbb')"
                    class="el-icon-circle-close del_icon"
                  ></i>
                </div>
              </template>
            </div>
          </div>
        </template>
        <template slot="fileCwbgForm" slot-scope="scope">
          <div class="upload-container">
            <WordUpload
              @showFileName="showFileNameCwbg"
              fileMenuName="保理业务财务报告附件"
              :id="virtualId"
              :plain="true"
              :tip="true"
            />
            <div class="">
              <template v-for="(item, index) in fileCwbg">
                <div class="file_wrapper" :key="index">
                  <a
                    class="file_button"
                    target="_blank"
                    :href="
                      isWord(item.fileUrl)
                        ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                          item.fileUrl
                        : item.fileUrl
                    "
                    type="text"
                    size="small"
                  >
                    {{ item.fileName }}
                  </a>
                  <i
                    @click="downLoadFile(item.id)"
                    class="el-icon-download del_icon"
                  ></i>
                  <i
                    @click="delFile(item.id, index, 'fileCwbg')"
                    class="el-icon-circle-close del_icon"
                  ></i>
                </div>
              </template>
            </div>
          </div>
        </template>
        <template slot="menuLeft">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            v-if="!readOnly"
            @click.stop="handleAdd()"
            >上传财务报告
          </el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-edit"
            plain
            v-if="!readOnly"
            @click.stop="handleEdit()"
            >修改
          </el-button>
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            plain
            v-if="!readOnly"
            @click.stop="handleDelete()"
            >删除
          </el-button>
          <el-dropdown size="small" trigger="click" v-if="!readOnly">
            <el-button type="primary" plain size="small">
              <i class="el-icon-download"></i>
              模板下载
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="handleTemplate(1)">
                &nbsp;&nbsp;工业 &nbsp;&nbsp;
              </el-dropdown-item>
              <el-dropdown-item @click.native="handleTemplate(2)">
                &nbsp;&nbsp;教育 &nbsp;&nbsp;
              </el-dropdown-item>
              <el-dropdown-item @click.native="handleTemplate(3)">
                &nbsp;&nbsp;医疗 &nbsp;&nbsp;
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </avue-crud>
    </div>
  </div>
</template>
<script>
import { downLoadTemplate, downLoadTemplateGet } from "@/router/downLoadTem";
import { factoringTableConfig } from "./config";
import * as api from "@/api/factoring/factoringCustomer";
import * as dictionaries from "@/api/zd/dictionaries";
import WordUpload from "@/components/wordUpload/wordUpload";
import { getToken } from "@/util/auth";
export default {
  name: "visit",
  data() {
    return {
      selectionList: [],
      checkUserList: [],
      checkdepartment: [],
      form: {},
      // filterSearchForm: {},
      files: "",
      drawer: false,
      id: "",
      tableConfig: factoringTableConfig(this.getMoney),
      sortOption: "",
      optionColumn: {},
      tableData: [],
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      loading: false,
      virtualId: -1,
      fileCwbb: [],
      fileCwbg: [],
    };
  },
  components: {
    WordUpload,
    downLoadTemplate,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dateRange() {
      const { cycle, reportDate } = this.form;
      return { cycle, reportDate };
    },
  },
  watch: {
    dateRange: {
      handler() {
        this.$nextTick(() => {
          if (this.form.cycle && this.form.reportDate) {
            let dateList = this.form.reportDate.split("-");

            if (this.form.cycle == 2) {
              this.form.cycleReportDate =
                dateList[0] +
                (0 < Number(dateList[1]) && Number(dateList[1]) < 7
                  ? "上"
                  : "下") +
                "半年年度报告";
            } else if (this.form.cycle == 3) {
              this.form.cycleReportDate =
                dateList[0] +
                "年第" +
                (0 < Number(dateList[1]) && Number(dateList[1]) < 4
                  ? "一"
                  : 3 < Number(dateList[1]) && Number(dateList[1]) < 7
                  ? "二"
                  : 6 < Number(dateList[1]) && Number(dateList[1]) < 10
                  ? "三"
                  : "四") +
                "季度年度报告";
            } else if (this.form.cycle == 4) {
              this.form.cycleReportDate =
                dateList[0] + "年" + Number(dateList[1]) + "月月度报告";
            } else {
              this.form.cycleReportDate = dateList[0] + "年年度报告";
            }
          }
        });
      },
      deep: true,
    },
  },
  mounted() {
    this.sortOption = this.tableConfig.column;

    // this.queryTableData();
  },
  methods: {
    queryInventedId() {
      let self = this;
      api.queryInventedId().then((res) => {
        if (res["data"]["code"] == 200) {
          self.virtualId = res["data"]["data"];
        }
      });
    },
    selectionChange(list) {
      this.selectionList = list;
    },

    saveData(row) {
      this.$refs.cloudtage.save(row);
    },

    searchChange(str, done) {
      this.queryTableData();
      done();
    },

    async queryTableData() {
      this.loading = true;
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        blCustId: this.$route.params.id,
        ...this.searchForm,
      };
      let res = await api.getBlfinancialreport(params);
      if (res.data.code == 200) {
        let data = res.data.data.records;

        this.tableData = data;
        this.page.total = res.data.data.total;
        this.loading = false;
      } else {
        this.$message.error(res.data.msg);
        this.loading = false;
      }
    },

    //新增
    handleAdd() {
      this.queryInventedId();
      Object.assign(this.form, {});
      this.$refs.crud.rowAdd();
    },
    //新增
    rowSave(row, done, loading) {
      this.submitCustcarbl(row, done, loading);
    },
    //修改
    rowUpdate(row, index, done, loading) {
      this.submitCustcarbl(row, done, loading);
    },
    // 新增修改 接口
    submitCustcarbl(row, done, loading) {
      let formData = new FormData();
      formData.append("file", row.file);
      formData.append("type", row.type);
      formData.append("reportType", row.reportType);
      formData.append("cycle", row.cycle);
      formData.append("reportDate", row.reportDate);
      formData.append("isConsolidated", row.isConsolidated);
      formData.append("name", row.cycleReportDate);
      formData.append("id", this.virtualId);
      formData.append("blCustId", this.$route.params.id);
      let data = {
        // type: row.type,
        // reportType: row.reportType,
        // cycle: row.cycle,
        // reportDate: row.reportDate,
        // isConsolidated: row.isConsolidated,
        // name: row.cycleReportDate,
        // file: this.form.file,
        // id: this.virtualId,
      };
      api.submitBlfinancialreport(formData).then(
        () => {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          // 数据回调进行刷新
          done(row);
          this.queryTableData();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    handleEdit() {
      if (this.selectionList.length > 1) {
        this.$message.error("只能选择一条数据进行编辑");
      } else if (this.selectionList.length == 1) {
        let data = this.selectionList[0];
        this.virtualId = data.id;
        this.getFileMenuByName(data.id, "保理业务财务报表附件", "fileCwbb");
        this.getFileMenuByName(data.id, "保理业务财务报告附件", "fileCwbg");
        this.$refs.crud.rowEdit(data);
      } else {
        this.$message.error("请选择一条数据进行编辑");
      }
    },
    //通过名称获取菜单
    getFileMenuByName(id, fileMenuName, name) {
      dictionaries
        .getFileMenuByName({ fileMenuName })
        .then((res) => {
          this.findFileByOtherId(id, res.data.data.id, name);
        })
        .catch((res) => {
          console.log(res);
        });
    },
    findFileByOtherId(id, baFileMenuId, name) {
      dictionaries
        .findFileByOtherId({
          fileOtherId: id,
          baFileMenuId: baFileMenuId,
        })
        .then((res) => {
          this[name] = res.data.data;
          this.form[name] = res.data.data;
          // this.form[name + "Id"] = res.data.data;
        })
        .catch((res) => {});
    },
    handleDelete() {
      let self = this;

      this.$confirm("确定删除选择的数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
         
          let ids = this.selectionList.map((item) => {
            return item.id;
          });
          let res = await api.removeBlfinancialreport({ ids: ids.join(",") });
          if (res.data.code == 200) {
            self.$message({
              type: "success",
              message: "删除成功",
            });
            self.queryTableData();
          }
        })
        .catch(() => {});
    },
    showFileNameCwbb(data, index, raw) {
      this.fileCwbb = data;
      this.form.fileCwbb = data;
      this.form.file = raw;
      
    },
    showFileNameCwbg(data) {
      this.fileCwbg = data;
      this.form.fileCwbg = data;
    },
    downLoadFile(id) {
      downLoadTemplate("/api/file/down", {
        id,
      }).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },
    //删除附件
    delFile(fileId, index, name) {
      this.$confirm("确定将附件删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return dictionaries.deleteFile({
            fileId,
          });
        })
        .then(() => {
          this[name].splice(index, 1);
          this.formData[name].splice(index, 1);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
    },
    handleTemplate(type) {
      downLoadTemplateGet("/api/bl/blfinancialreport/exportTemplate", {
        type,
      }).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.factoring-container {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .project-table {
    background: #ffff;
    padding: 25px;
  }
  .project-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }
}
.none-border {
  border: 0;
  background-color: transparent !important;
}
/deep/ .avue-crud__menu {
  min-height: 0;
}
</style>
<style lang="scss">
.factoring-container {
  .el-table__fixed,
  .el-table__fixed-right {
    height: calc(100% - 10px) !important;
  }
  .el-table__fixed-footer-wrapper {
    display: none !important;
  }
}
</style>

